export enum PipelinesRoles {
  CREATOR = 'roles.pipelinesCreator',
  VIEWER = 'roles.pipelinesViewer',
  EDITOR = 'roles.pipelinesEditor',
}
